import api from '@api';
import { call, put, takeEvery } from 'redux-saga/effects';
import { getProviderTransferCompaniesListFetchFailure, getProviderTransferCompaniesListFetchSuccess } from './reducer';
import { ProviderTransferCompaniesListResType } from 'src/types/providerTransferCompaniesList';

const getProviderTransferCompaniesListFetchRequest = async () => {
    const res = await api('get', 'api/secure/provider-transfer-companies');
    return res.data.data;
};

function* getProviderTransferCompaniesListFetch() {
    try {
        const response: ProviderTransferCompaniesListResType = yield call((): any => getProviderTransferCompaniesListFetchRequest());
        yield put(getProviderTransferCompaniesListFetchSuccess(response));
    } catch (error) {
        yield put(getProviderTransferCompaniesListFetchFailure({ error }));
    }
}

export function* getProviderTransferCompaniesListFetchWatch() {
    yield takeEvery('providerTransferCompaniesList/getProviderTransferCompaniesListFetch', getProviderTransferCompaniesListFetch);
}
